export default(key, lang) => {
  let mapping = {
    networkError: {
      en_US: 'Looks like you may be offline. Please check your internet connection and try again.',
      de_DE: 'Sieht so aus, als wären Sie möglicherweise offline. Bitte überprüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.',
      el_GR: 'Φαίνεται ότι μπορεί να είστε εκτός σύνδεσης. Ελέγξτε τη σύνδεση στο Internet και δοκιμάστε ξανά.',
      es_ES: 'Parece que puedes estar desconectado. Verifique su conexión a Internet e intente nuevamente.',
      fr_FR: 'Il semble que vous soyez déconnecté. S\'il vous plaît, vérifiez votre connexion à internet et réessayez.',
      fr_CA: 'Il semble que vous soyez déconnecté. S\'il vous plaît, vérifiez votre connexion à internet et réessayez.',
      it_IT: 'Sembra che tu possa essere offline. Per favore controlla la tua connessione Internet e prova di nuovo.',
      pl_PL: 'Wygląda na to, że możesz być offline. Sprawdź swoje połączenie internetowe i spróbuj ponownie.',
      th_TH: 'ดูเหมือนว่าคุณอาจออฟไลน์ โปรดตรวจสอบการเชื่อมต่ออินเทอร์เน็ตของคุณแล้วลองอีกครั้ง',
      zh_CN: '看來您可能處於離線狀態。請檢查您的互聯網連接，然後重試。',
      pt_BR: 'Parece que você pode estar offline. Por favor verifique sua conexão com a internet e tente novamente.',
      ja_JP: 'オフラインのようです。インターネット接続を確認して、もう一度お試しください。',
    },
    sessionTimeout: {
      en_US: 'Your session has timed out. Please login again.',
      de_DE: 'Deine Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.',
      el_GR: 'Η συνεδρία σας έχει λήξει. Παρακαλούμε συνδεθείτε ξανά.',
      es_ES: 'Tu sesión ha expirado. Por favor ingrese nuevamente.',
      fr_FR: 'Votre session a expiré. Veuillez vous reconnecter.',
      fr_CA: 'Votre session a expiré. Veuillez vous reconnecter.',
      it_IT: 'La tua sessione è scaduta. Per favore esegui l\'accesso di nuovo.',
      pl_PL: 'Twoja sesja wygasła. Proszę, zaloguj się ponownie.',
      th_TH: 'หมดเวลาการใช้งาน. กรุณาเข้าสู่ระบบอีกครั้ง',
      zh_CN: '您的会话已超时。 请重新登录。',
      pt_BR: 'Sua sessão expirou. Por favor faça login novamente.',
      ja_JP: 'あなたのセッションは時間切れです。 もう一度ログインしてください。',
    }
  };

  return mapping[key][lang];
};
